module.exports = __webpack_public_path__ + "static/super-admin-tax-form-e92bcda58994de4270d180f2d734d0d1.png";